import { CountriesMockApi } from './countries/api';
import { IconsMockApi } from './icons/api';
import { NavigationMockApi } from './navigation/api';

export const mockApiServices = [IconsMockApi, NavigationMockApi, CountriesMockApi];
